/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { NotificationPreferencesUpdateCategories } from './notificationPreferencesUpdateCategories';

export interface NotificationPreferencesUpdate {
  categories?: NotificationPreferencesUpdateCategories;
  daily_snapshot_enabled?: boolean | null;
}
